import "./style.scss";
import { useState } from "react";
import AOPConfig from "./AOPConfig/AOPConfig";
import AOPPrev from "./AOPPrev/AOPPrev";
import { AOPMaltaAdmissionData } from "@/src/types/admissionOffice";
import type { AdmissionOfficeCountry } from "../../admissionOfficeCountry";

const emptyAdmissionState = (): AOPMaltaAdmissionData => ({
  currentDate: "",
  fullName: "",
  dateOfBirth: "",
  nationality: "",
  course: "",
  userOffice: "01",
  whose_doc: "",
  title: "",
  duration: "",
  mediumOfInstruction: "",
  coursePrefix: "",
  body: [],
  invoiceBody: [],
});

export interface AOPAdmissionLetterBasicLayoutProps {
  country: AdmissionOfficeCountry;
}

const AOPAdmissionLetterBasicLayout = ({ country }: AOPAdmissionLetterBasicLayoutProps) => {
  const [dataForGeneration, setDataForGeneration] = useState<AOPMaltaAdmissionData>(emptyAdmissionState);
  const [bodyForPrev, setBodyForPrev] = useState<AOPMaltaAdmissionData>(emptyAdmissionState);
  const [showInvoiceInPreview, setShowInvoiceInPreview] = useState(false);

  return (
    <div className="container admission-office-page">
      <AOPConfig
        country={country}
        dataForGeneration={dataForGeneration}
        setDataForGeneration={setDataForGeneration}
        setBodyForPrev={setBodyForPrev}
        setShowInvoiceInPreview={setShowInvoiceInPreview}
      />
      <AOPPrev country={country} bodyForPrev={bodyForPrev} showInvoiceInPreview={showInvoiceInPreview} />
    </div>
  );
};

export default AOPAdmissionLetterBasicLayout;
